import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M15 2C18.3137 2 21 4.68629 21 8C21 11.2384 18.4344 13.8776 15.2249 13.9959L15 14H10V16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10V21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21V18H4C3.44772 18 3 17.5523 3 17C3 16.4477 3.44772 16 4 16H8V14H4C3.44772 14 3 13.5523 3 13C3 12.4872 3.38604 12.0645 3.88338 12.0067L4 12H8V3C8 2.44772 8.44772 2 9 2H15ZM15 4H10V12H15C17.2091 12 19 10.2091 19 8C19 5.8578 17.316 4.10892 15.1996 4.0049L15 4Z" />,
  'Ruble'
);
